const UserTypeMapEnum = {
  ADMIN: "Admin",
  STUDENT: "Estudante",
  SCHOLARSHIP_STUDENT: "Estudante Bolsista",
  EXTERNAL: "Externo",
};

export default UserTypeMapEnum;
